<template>
  <div>
    <div class="card-body py-0 px-0 border border-gray rounded-3">
      <div class="card-header bg-gray">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="mb-0">
            <i class="fas fa-filter text-white me-2"></i>Filtros de Tif Turnos
          </h5>
          <button
            type="button"
            class="btn bg-navy btn-sm"
            @click="cargarDatos"
            :disabled="cargando"
          >
            <i
              class="fas fa-sync-alt me-1"
              :class="{ 'fa-spin': cargando }"
            ></i>
            Actualizar
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-dark"
            @click="mostrarFiltros = !mostrarFiltros"
            :title="mostrarFiltros ? 'Ocultar filtros' : 'Mostrar filtros'"
          >
            <i
              :class="
                mostrarFiltros ? 'fas fa-chevron-up' : 'fas fa-chevron-down'
              "
            ></i>
            {{ mostrarFiltros ? "Ocultar" : "Mostrar" }}
          </button>
        </div>
      </div>
      <div class="card-body bg-light" v-show="mostrarFiltros">
        <div class="row">
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-building text-primary me-1"></i> Empresa
            </label>
            <v-select
              v-model="empresa"
              :options="listasForms.empresas"
              label="razon_social"
              placeholder="Todas las empresas"
              class="form-control-sm p-0"
              @input="getSelectEmpresa()"
              @search="buscarEmpresas"
            ></v-select>
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-truck text-warning me-1"></i> Vehículo
            </label>
            <v-select
              v-model="vehiculo"
              :options="listasForms.vehiculos"
              label="placa"
              placeholder="Todos los vehículos"
              class="form-select"
              @input="getSelectVehiculo()"
              @search="buscarVehiculos"
            ></v-select>
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-user text-secondary me-1"></i> Conductor
            </label>
            <v-select
              v-model="conductor"
              class="form-select"
              :options="listasForms.conductores"
              label="nombre"
              placeholder="Todos los conductores"
              @input="getSelectConductor()"
              @search="buscarConductores"
            ></v-select>
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-truck text-warning me-1"></i> Remolque
            </label>
            <v-select
              v-model="remolque"
              class="form-select"
              :options="listasForms.remolques"
              label="placa"
              placeholder="Todos los remolques"
              @input="getSelectRemolque()"
              @search="buscarRemolques"
            ></v-select>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-route text-info me-1"></i> Ruta
            </label>
            <v-select
              class="form-select"
              :options="listasForms.rutas"
              v-model="ruta"
              placeholder="Nombre"
              @input="getSelectRuta()"
              label="nombre"
              @search="buscarRutas"
            ></v-select>
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-calendar text-primary me-1"></i> Fecha Desde
            </label>
            <input
              type="date"
              class="form-control form-control-sm"
              v-model="filtros.fecha_inicial"
              :max="fechaMaxima"
            />
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-calendar text-primary me-1"></i> Fecha Hasta
            </label>
            <input
              type="date"
              class="form-control form-control-sm"
              v-model="filtros.fecha_final"
              :max="fechaMaxima"
            />
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted">
              <i class="fas fa-route text-danger me-1"></i> Tipo Servicio
            </label>
            <select
              class="form-control form-control-sm"
              v-model="filtros.tipo_servicio"
              placeholder="Seleccione el tipo de servicio"
            >
              <option value="">Seleccione...</option>
              <option value="1">Postulacion</option>
              <option value="2">Turno</option>
            </select>
          </div>
          <div class="col-md-3 mt-2">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-hashtag text-danger me-1"></i>
              Servicio
            </label>
            <input
              type="number"
              class="form-control form-control-sm"
              v-model="filtros.entidad_id"
              placeholder="Ej: 12345"
              :disabled="!filtros.tipo_servicio"
            />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12">
            <div class="d-flex justify-content-center">
              <button
                type="button"
                class="btn btn-success btn-sm"
                @click="cargarDatos"
                :disabled="cargando"
              >
                <i class="fas fa-search me-1" v-if="!cargando"></i>
                <i class="fas fa-spinner fa-spin me-1" v-else></i>
                {{ cargando ? "Buscando..." : "Buscar" }}
              </button>
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                @click="limpiarFiltros"
              >
                <i class="fas fa-eraser me-1"></i> Limpiar Filtros
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabla de Postulaciones y Viajes -->
    <div class="card shadow mt-2">
      <div class="card-header bg-gradient-secondary text-white">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="mb-0">
            <i class="fas fa-list me-2"></i> Tif Turnos
            <span class="badge bg-light text-dark ml-1"
              >{{ turnos.total }} registros</span
            >
          </h5>
        </div>
      </div>
      <div class="card-body p-0">
        <div v-if="cargando" class="text-center p-4">
          <div class="spinner-border text-success" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
          <p class="mt-2">Cargando datos...</p>
        </div>
        <div
          v-else-if="!turnos.data || turnos.data.length === 0"
          class="text-center p-4"
        >
          <i class="fas fa-info-circle fa-3x text-muted mb-3"></i>
          <p class="text-muted">No hay turnos disponibles</p>
        </div>
        <div v-else class="table-responsive">
          <table
            class="table table-striped table-hover mb-0 text-nowrap table-bordered"
          >
            <thead class="table-dark">
              <tr>
                <th>Acciones</th>
                <th>#</th>
                <th>Últ. Novedad</th>
                <th>Vehículo</th>
                <th>Remolque</th>
                <th>Conductor</th>
                <th>Empresa</th>
                <th>Ruta</th>
                <th>Tipo Tarifa</th>
                <th>Producto</th>
                <th>Turno</th>
                <th>Tipo Vehiculo</th>
                <th>Estado</th>
                <th>Fecha Inicial</th>
                <th>Fecha Final</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in turnos.data"
                :key="index"
                class="text-center"
              >
                <td class="text-center">
                  <div style="position: static; z-index: auth">
                    <button
                      type="button"
                      class="btn btn-dark btn-sm"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-align-justify"></i>
                    </button>
                    <div class="dropdown-menu">
                      <a
                        class="dropdown-item"
                        style="cursor: pointer"
                        @click="abrirModal(item, item.vehiculo?.gpss)"
                      >
                        <i class="fa fa-map-signs"></i>
                        Crear Seguimiento
                      </a>
                    </div>
                  </div>
                </td>
                <td class="text-center">
                  <button
                    type="button"
                    class="badge bg-secondary text-white"
                    data-toggle="modal"
                    data-target="#modal-form-detViaje"
                  >
                    {{ item.id }}
                  </button>
                </td>
                <td class="text-center">
                  <div v-if="item.ultima_novedad">
                    <span class="badge bg-warning text-white">
                      {{
                        item.ultima_novedad?.tipo_novedad == 1
                          ? item.ultima_novedad?.nSubNovedadGps
                          : item.ultima_novedad?.tipo_novedad == 2
                          ? item.ultima_novedad?.nSubNovedadRuta
                          : item.ultima_novedad?.tipo_novedad == 4
                          ? item.ultima_novedad?.nSubNovedadGeocerca
                          : "N/A"
                      }}
                      <div>
                        {{ item.ultima_novedad.nTipoNovedad }}
                      </div>
                    </span>
                    <div>
                      <small>
                        {{ item.ultima_novedad.fecha_novedad }}
                      </small>
                    </div>
                  </div>
                  <span
                    v-else
                    class="badge alert-default-success border-success"
                  >
                    <i class="fas fa-check mr-1"></i>
                    Sin novedad
                  </span>
                </td>
                <td class="text-center">
                  <div class="d-flex flex-column align-items-center">
                    <div class="d-flex align-items-center">
                      <span class="fw-semibold">{{
                        item.vehiculo?.placa || "N/A"
                      }}</span>
                      <i
                        v-if="item.vehiculo?.fecha_ultimo_gps"
                        :class="[
                          'ml-1 fas',
                          gpsDentroDe2Horas(item.vehiculo?.fecha_ultimo_gps)
                            ? 'fa-check-circle text-success'
                            : 'fa-times-circle text-danger',
                        ]"
                        :title="
                          `Último GPS: ${formatFecha(
                            item.vehiculo?.fecha_ultimo_gps,
                          )}`
                        "
                      ></i>
                      <i
                        v-else
                        class="fas fa-minus-circle text-muted"
                        title="Sin GPS"
                      ></i>
                    </div>
                  </div>
                </td>
                <td class="text-center">
                  <span v-if="item.remolque?.placa">
                    {{ item.remolque?.placa }}
                  </span>
                  <span class="text-muted" v-else> Sin remolque </span>
                </td>
                <td class="text-center">
                  <div v-if="item.conductor">
                    <div>
                      {{ item.conductor.nombres }}
                      {{ item.conductor.apellidos }}
                    </div>
                    <small class="text-muted">{{
                      item.conductor.numero_documento
                    }}</small>
                  </div>
                  <span v-else class="text-muted">N/A</span>
                </td>
                <td class="text-center">{{ item.empresa.razon_social }}</td>
                <td class="text-center">{{ item.ruta.nombre }}</td>
                <td class="text-center">{{ item.nTipoTarifa }}</td>
                <td class="text-center">{{ item.producto.nombre }}</td>
                <td class="text-center">{{ item.turno.nombre }}</td>
                <td class="text-center">
                  {{ item.vehiculo.tipo_vehiculo.nombre }}
                </td>
                <td class="text-center">
                  <span
                    class="badge"
                    :class="
                      getEstadoColor(
                        item.turno ? item.turno.estado : item.estado,
                      )
                    "
                  >
                    {{ item.nEstado }}
                  </span>
                </td>
                <td class="text-center">{{ item.fecha_ini }}</td>
                <td class="text-center">{{ item.fecha_fin }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- Paginación compacta -->
      <div class="card-footer bg-light pb-0" v-if="!cargando">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div
              v-if="turnos.total"
              class="text-muted"
              style="font-size: 0.8rem"
            >
              <i class="fas fa-info-circle me-1"></i>
              Mostrando del
              <strong>{{ turnos.from }}</strong> al
              <strong>{{ turnos.to }}</strong> de un total:
              <strong>{{ turnos.total }}</strong> Registros
            </div>
            <div class="pb-2" v-else>
              <span class="badge bg-danger" style="font-size: 0.75rem">
                <i class="fas fa-exclamation-triangle me-1"></i>
                No hay registros para mostrar
              </span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-flex justify-content-end">
              <pagination
                :data="turnos"
                @pagination-change-page="cargarDatos"
                :limit="5"
                class="float-right"
              ></pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <GestionHidrocarburosDet ref="gestionHidrocarburosDet" /> -->
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import pagination from "laravel-vue-pagination";
/* import GestionHidrocarburosDet from "./GestionHidrocarburosDet.vue"; */

const $ = window.$;

export default {
  name: "GestionTif",
  components: {
    vSelect,
    pagination,
    /* GestionHidrocarburosDet, */
  },
  data() {
    return {
      cargando: false,
      turnos: {},
      filtros: {
        tipo_servicio: null,
        entidad_id: null,
        empresa_id: null,
        vehiculo_id: null,
        turno_id: null,
        ruta_id: null,
        fecha_inicial: null,
        fecha_final: null,
        tipo_tarifa: null,
      },
      empresa: {},
      vehiculo: {},
      remolque: {},
      conductor: {},
      ruta: {},
      listasForms: {
        empresas: [],
        vehiculos: [],
        remolques: [],
        conductores: [],
        turnos: [],
        rutas: [],
        tipo_tarifas: [],
      },
      mostrarFiltros: true,
      ultimaActualizacion: moment().format("DD/MM/YYYY HH:mm:ss"),
    };
  },
  computed: {
    fechaMaxima() {
      return moment().format("YYYY-MM-DD");
    },
  },

  methods: {
    init() {
      this.cargarDatos();
    },

    abrirModal(novedad, gps) {
      this.$parent.$refs.SeguimientoNovedades.init("tif", novedad, gps);
      this.$nextTick(() => {
        $("#modal-form-seguimiento-novedades").modal("show");
      });
    },

    gpsDentroDe2Horas(fecha) {
      if (!fecha) return false;
      const haceDosHoras = moment().subtract(2, "hours");
      return moment(fecha).isAfter(haceDosHoras);
    },

    buscarEmpresas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/admin/empresas/lista?razon_social=" + search;
        axios
          .get(url, {
            params: {
              linea_negocio_id: [3],
            },
          })
          .then(function(response) {
            me.listasForms.empresas = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarVehiculos(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/admin/vehiculos/lista?placa=" + search;
        axios
          .get(url, {
            params: {
              linea_negocio_id: [3],
            },
          })
          .then(function(response) {
            me.listasForms.vehiculos = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarConductores(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/admin/conductores/lista?nombre=" + search;
        axios
          .get(url, {
            params: {
              linea_negocio_id: [3],
            },
          })
          .then(function(response) {
            me.listasForms.conductores = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarRemolques(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/admin/remolques/lista?placa=" + search;
        axios
          .get(url, {
            params: {
              linea_negocio_id: [3],
            },
          })
          .then(function(response) {
            me.listasForms.remolques = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarRutas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/tif/rutas/lista?nombre=" + search;
        axios
          .get(url)
          .then(function(response) {
            me.listasForms.rutas = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    async cargarDatos(page = 1) {
      this.cargando = true;
      try {
        const response = await axios.get(
          "/api/tif/centralTrafico/getTurnosTif?page=" + page,
          {
            params: this.filtros,
          },
        );
        this.turnos = response.data;
        this.ultimaActualizacion = moment().format("DD/MM/YYYY HH:mm:ss");
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Error",
          text:
            "Error al cargar los datos: " +
            (error.response?.data?.message || error.message),
        });
      } finally {
        this.cargando = false;
      }
    },

    getSelectEmpresa() {
      this.filtros.empresa_id = null;
      if (this.empresa) {
        this.filtros.empresa_id = this.empresa.id;
      }
      this.cargarDatos();
    },

    getSelectVehiculo() {
      this.filtros.vehiculo_id = null;
      if (this.vehiculo) {
        this.filtros.vehiculo_id = this.vehiculo.id;
      }
      this.cargarDatos();
    },

    getSelectRemolque() {
      this.filtros.remolque_id = null;
      if (this.remolque) {
        this.filtros.remolque_id = this.remolque.id;
      }
      this.cargarDatos();
    },

    getSelectConductor() {
      this.filtros.conductor_id = null;
      if (this.conductor) {
        this.filtros.conductor_id = this.conductor.id;
      }
      this.cargarDatos();
    },

    getSelectRuta() {
      this.filtros.ruta_id = null;
      if (this.ruta) {
        this.filtros.ruta_id = this.ruta.id;
      }
      this.cargarDatos();
    },

    limpiarFiltros() {
      this.filtros = {
        empresa_id: null,
        vehiculo_id: null,
        remolque: null,
        conductor_id: null,
        turno_id: null,
        ruta_id: null,
        fecha_inicial: null,
        fecha_final: null,
        tipo_tarifa: null,
      };
      this.cargarDatos();
    },

    getEstadoColor(estado) {
      const colores = {
        1: "bg-primary", // Iniciado
        2: "bg-info", // En Sitio Cargue
        3: "bg-warning", // En Sitio Descargue
        4: "bg-success", // En Sitio Cargue o Descargue
        5: "bg-secondary", // En Sitio Disponibilidad
        6: "bg-danger", // En Sit io Indisponibilidad
        7: "bg-dark", // Transito
      };
      return colores[estado] || "bg-secondary";
    },

    formatFecha(fecha) {
      return moment(fecha).format("DD/MM/YYYY HH:mm");
    },

    llenarModalEntidad(data, entidad) {
      let dataForm = {};
      dataForm = {
        tipo_entidad_type: data.tipo,
        tipo_entidad_id: data.id,
        vehiculo_id: data.vehiculo_id,
        tipo_vehiculo_id: data.tipo_vehiculo_id,
        vehiculo_placa: data.vehiculo_placa,
        remolque_id: data.remolque_id,
        remolque_placa: data.remolque_placa,
        conductor_id: data.conductor_id,
        conductor_documento: data.conductor_documento,
        conductor_nombre:
          data.conductor_nombres + " " + data.conductor_apellidos,
        ruta_id: data.ruta_id,
        ruta_nombre: data.ruta_nombre,
        empresa_id: data.empresa_id,
        sitio_cargue_id: data.sitio_cargue_id,
        estado_entidad: data.estado_nombre,
      };
      this.$refs.gestionHidrocarburosCambios.getIndex(dataForm, entidad);
    },
  },
};
</script>
